export default __webpack_public_path__ + "static/media/funds__closing-funds.a84e1246.png";